export const CONTACTS_PER_PAGE = 20;
